module.exports = "<svg viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.7 9.7h-7.1L14.1 2c-.1-.5-.6-1-1.1-1-.5 0-1 .5-1.1 1L9.4 9.7H2.3c-.6 0-1.3.2-1.3 1 0 .4.1 1 .5 1.2l6 3.6-2.4 8c-.1.5.2 1.1.6 1.3.2.1.4.2.6.2.3 0 .5 0 .8-.2L13 20l5.9 4.8c.2.2.4.2.8.2.2 0 .4-.1.7-.2.4-.2.7-.8.5-1.3l-2.4-8 6-3.6c.4-.2.5-.8.5-1.2 0-.8-.7-1-1.3-1z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/star.svg
// module id = 95
// module chunks = 0